import { FormValues, getValue, InputFormGroup } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Fields as TagDetailsFields, TagsEditPanel } from "../../components/TagsEditPanel/TagsEditPanel";
import { useOperation } from "../../hooks/useOperation";
import { OperationActionProps } from "../OperationTypes";
import { newVmDbUpdateTagsPdb, VmDbUpdateTagsPdbProps } from "./VmDbUpdateTagsPdb";

export interface VmDbEditTagsPdbProps extends OperationActionProps {
  databaseId: string | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  defaultTags?: { name: string; value: any; }[];
}

const VmDbEditTagsPdb = (
  { targetId, location, databaseId, defaultTags, onExecute, onCancel }: VmDbEditTagsPdbProps,
): JSX.Element => {
  const { trigger: triggerUpdateTagsPdb } = useOperation<VmDbUpdateTagsPdbProps>(newVmDbUpdateTagsPdb);

  return (
    <TagsEditPanel
      targetId={targetId}
      title={Messages.labels.editTags()}
      tagsDefaultValue={defaultTags || []}
      onSubmit={(formValues: FormValues) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const tags: { name: string; value: any; }[] = getValue(formValues, TagDetailsFields.Tags, InputFormGroup);
        triggerUpdateTagsPdb({
          databaseId,
          tags,
          location,
          onExecute,
        });
      }}
      onClose={onCancel}
    />
  );
};

export const newVmDbEditTagsPdb = (
  props: VmDbEditTagsPdbProps,
): JSX.Element => (<VmDbEditTagsPdb {...props} />);
